import { corsReadUrl } from '../../canvas/images';
import { cachedFetch } from '../../services/mediaCache';

/**
 * An SVG kept on Flobi's storage, read as text: what the canvas turns into layers. A brand's
 * logos and graphics are read this way, and so are the SVGs in My Stuff.
 */
const svgTexts = new Map<string, Promise<string>>();
export function svgText(url: string): Promise<string> {
  let text = svgTexts.get(url);
  if (!text) {
    text = cachedFetch(corsReadUrl(url), { mode: 'cors' }).then((response) => {
      if (!response.ok) throw new Error(`the server answered ${response.status}`);
      return response.text();
    });
    // A failed read is asked for again next time, not remembered.
    text.catch(() => svgTexts.delete(url));
    svgTexts.set(url, text);
  }
  return text;
}
